import styled, { css } from 'styled-components'

import { Button } from 'primsell-shared-layer/components'
import { ZoomInIcon as ZoomInIconAsset } from 'primsell-shared-layer/assets/icons'

import { ImagePreviewContainerSizeT } from './image-preview-container.types'

export interface ImagePreviewContainerProps {
  size: ImagePreviewContainerSizeT
}

export interface SizeConfig {
  width: string
  height: string
  borderRadius?: string
  border?: string
}

const sizeConfig: Record<ImagePreviewContainerSizeT, SizeConfig> = {
  large: {
    width: '534px',
    height: '575px',
    borderRadius: '12px',
  },
  medium: {
    width: '242px',
    height: '303px',
    borderRadius: '8px 8px 0 0',
  },
  small: {
    width: '100%',
    height: 'auto',
    borderRadius: '4px',
  },
}

export const Container = styled.div<ImagePreviewContainerProps>`
  position: relative;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;

  @media screen and (min-width: 560px) {
    ${({ size }) => `
    width: ${sizeConfig[size].width};
    height: ${sizeConfig[size].height};
    border-radius: ${sizeConfig[size].borderRadius ?? '4px'};
  `}
  }
`

export const NFTPreview = styled.img`
  display: block;
  height: 100%;
  width: 100%;

  object-fit: contain;

  @media screen and (min-width: 560px) {
    object-fit: cover;
  }
`

export const ZoomInIcon = styled(ZoomInIconAsset)<{ size?: ImagePreviewContainerSizeT }>`
  ${({ size }) =>
    size === 'medium' &&
    css`
      width: 16px;
      height: 16px;
    `};
`

export const ZoomInButton = styled(Button)`
  display: none;

  @media screen and (min-width: 560px) {
    display: block;

    position: absolute;
    top: 16px;
    right: 16px;
  }
`
